import React, { useState, useEffect } from "react"
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"

import Home from "./Pages/Home"
import State from "./Pages/State"
import Embed from "./Pages/Embed"
import StateDonutEmbed from "./Pages/StateDonutEmbed"
import StateBarEmbed from "./Pages/StateBarEmbed"

import { Header, Footer } from "./Layout"

import "../assets/styles/global.scss"

export default function App() {
  const [enableTheme, setEnableTheme] = useState(true)

  useEffect(() => {
    const urlString = window.location.href.toLowerCase() || null
    const url = new URL(urlString)
    return url.searchParams.get("embed") === "true"
      ? setEnableTheme(false)
      : setEnableTheme(true)
  }, [])

  return (
    <Router>
      {enableTheme && <Header />}
      <Switch>
        <Route path="/" exact>
          <Home />
        </Route>
        <Route path="/state/:id">
          <State />
        </Route>
        <Route path="/embed">
          <Embed />
        </Route>
        <Route path="/state-donut-embed/:id">
          <StateDonutEmbed />
        </Route>
        <Route path="/state-bar-embed/:id">
          <StateBarEmbed />
        </Route>
      </Switch>
      {enableTheme && <Footer />}
    </Router>
  )
}
